// extracted by mini-css-extract-plugin
export default {"container":"MultipleQuestion_container__ZjENS","header":"MultipleQuestion_header__xpkbe","title":"MultipleQuestion_title__DZ5Lg","wrapper":"MultipleQuestion_wrapper__K1siT"};